import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { NonCommerceInfoContext } from '@repo/contexts';
import { LinkShape } from '@repo/utils/getLink';
import NavBar from '@repo/ui-components/dept/organisms/NavBar';
import NotificationCarousel from '../../../molecules/NotificationCarousel';

export default function DesktopNav({
  menuItems,
  notificationBanner,
  bannerShowing,
  carouselHeight,
}) {
  const { isNonCommerce } = useContext(NonCommerceInfoContext);

  const [atTopOfPage, setAtTopOfPage] = useState(true);
  useEffect(() => {
    const updateShowNav = () => {
      const distanceFromTopNavStartsBeingHidden = 40;
      const topOfPageMark = distanceFromTopNavStartsBeingHidden + 1;
      const { scrollY } = window;

      if (scrollY <= topOfPageMark && !atTopOfPage) {
        setAtTopOfPage(true);
      } else if (scrollY >= topOfPageMark * 2 && atTopOfPage) {
        setAtTopOfPage(false);
      }
    };

    updateShowNav();

    window.addEventListener('scroll', updateShowNav);
    return () => {
      window.removeEventListener('scroll', updateShowNav);
    };
  }, [atTopOfPage]);

  return (
    <Box
      display={{ base: 'none', lg: 'block' }}
      as={motion.header}
      pos="fixed"
      top="0px"
      animate={{
        transition: { duration: 0.4, ease: [1, 0.26, 0.51, 0.72] },
      }}
      zIndex="999"
      bg="transparent"
      mb={10}
      w="100%"
    >
      {!isNonCommerce && notificationBanner?.length > 0 && (
        <NotificationCarousel
          notificationBanner={notificationBanner}
          atTopOfPage={atTopOfPage}
          menuOpen={false}
          carouselHeight={carouselHeight}
        />
      )}
      <NavBar
        menuItems={menuItems}
        atTopOfPage={atTopOfPage}
        bannerShowing={bannerShowing}
      />
    </Box>
  );
}

DesktopNav.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      link: LinkShape,
    })
  ).isRequired,
  notificationBanner: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  bannerShowing: PropTypes.bool.isRequired,
  carouselHeight: PropTypes.number.isRequired,
};
